import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetBillingIntervalTypes,
  GetBillingIntervalTypesVariables
} from '@/graphql/contracts/_generated_/getBillingIntervalTypes.query';
import GetBillingIntervalTypesQuery from '@/graphql/contracts/getBillingIntervalTypes.query.gql';

export function getBillingIntervals(includeMultiyearIntervals: boolean = false): BillingInterval[] {
  const result = apolloClientContracts.readQuery<GetBillingIntervalTypes, GetBillingIntervalTypesVariables>({
    query: GetBillingIntervalTypesQuery,
    variables: {
      includeNonShowable: true
    }
  });

  if (!includeMultiyearIntervals && result?.billingIntervalTypes?.length) {
    return result.billingIntervalTypes.filter((interval) => {
      return interval.showable === true;
    });
  }

  return result?.billingIntervalTypes || [];
}
